import { Component, OnInit } from "@angular/core";
import { LocationStrategy } from "@angular/common";
import { Router, NavigationEnd, RouterOutlet } from "@angular/router";
import { AuthService } from "./core/authentication/services/auth.service";
import { environment } from "../environments/environment";
import { LogService } from "./shared/service/logging/log.service";
import { LogLevel } from "./shared/service/logging/log-level.model";
import { AppFooterComponent } from "./layout/footer/footer.component";
import { DialogHostComponent } from "./shared/modules/dialogs/dialog-host.component";
import { AppHeaderComponent } from "./layout/header/header.component";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    standalone: true,
    imports: [
        AppHeaderComponent,
        RouterOutlet,
        DialogHostComponent,
        AppFooterComponent,
    ],
})
export class AppComponent implements OnInit {
  title = "Upskill";
  constructor(
    private router: Router,
    private locStrat: LocationStrategy,
    public auth: AuthService,
    private logger: LogService
  ) {}

  authIsLoading = this.auth.isLoading;

  ngOnInit(): void {
    let isPopState = false;

    this.locStrat.onPopState(() => {
      isPopState = true;
    });
  }
}
